import { isNil } from 'ramda'
import { ElForm } from 'element-ui/types/form'
import { post, get, del } from '@/api/session'
import { get as getUser } from '@/api/session/user'
import { router } from '@/router'
import { sessionStore as store } from '@/store/session'
import { updateTokens, cleanTokens, updateTokensByStorage } from './token'
import { init as initPermission, cleanOwnPermisson } from './permission'
import { notify, alert, comfirm } from '@/utils/notification'
import { BasicLoginToken } from '@/models/session'
import { Nilable } from '@/models/helpers/common'

let codeToken: Nilable<string> = null

export async function fetchCaptcha() {
  try {
    const payload = await get()
    codeToken = payload.codeToken
    return `data:image/png;base64,${payload.captchaImage}`
  } catch (e) {
    notify(`获取验证码失败`, e)
    return ``
  }
}

type form = BasicLoginToken & { persistence: boolean }
export async function login({ persistence, ...token }: form, el?: ElForm) {
  if (isNil(codeToken)) {
    alert('请手动刷新验证码', new Error())
    return false
  }

  try {
    if (el) await el.validate()
  } catch (e) {
    return false
  }

  try {
    const { accessToken, refreshToken } = await post({ ...token, codeToken })
    updateTokens(accessToken, refreshToken, persistence)
  } catch (e) {
    alert(`登录失败`, e)
    return false
  }

  await loginSuccess()
  return true
}

export async function loginByStorage(to?: string) {
  const re = await updateTokensByStorage()
  if (re) await loginSuccess(to)
  return re
}

export async function comfirmLogout() {
  try {
    await comfirm('真的要退出登录吗?', { type: 'warning' })
    logout()
    notify('您已安全退出系统')
  } catch (e) {
    // DO Nothing
  }
}

export async function logout() {
  cleanTokens()
  cleanOwnPermisson()
  router.push('/login')
}

async function loginSuccess(to = '/') {
  await Promise.all([fetchUserInfo(), initPermission()])
  router.push(to)
  notify(`欢迎回来, ${store.user.username}!`)
}

async function fetchUserInfo() {
  try {
    const user = await getUser()
    store.updateUserInfo(user)
    return user
  } catch (e) {
    notify('获取用户信息失败', e)
    return null
  }
}
